import { defineMessages } from "react-intl";

const messages = defineMessages({
  accessLevelStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel",
    defaultMessage: "Step {index}: Select Access Level",
    description: "Select access level step in the style editor of a pin legend",
  },
  bucketsStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.buckets",
    defaultMessage: "Step {index}: Define Buckets",
    description: "Select buckets details step in the style editor of a pin legend",
  },
  classificationStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.classification",
    defaultMessage: "Step {index}: Choose Classification Method",
    description: "Select classification step in the style editor of a pin legend",
  },
  colorThemeStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.colorTheme",
    defaultMessage: "Step {index}: Choose color theme",
    description: "Select color theme step in the style editor of a pin legend",
  },
  datingMethodStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.datingMethod",
    defaultMessage: "Step {index}: Select dating method",
    description: "Select dating method step in the style editor of a pin legend",
  },
  flip: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.colorTheme.flipButton",
    defaultMessage: "{icon} Flip",
    description: "Flip button label in colors theme step in the style editor of a pin legend",
  },
  shapesStep: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.shapes",
    defaultMessage: "Step {index}: Choose shapes",
    description: "Select shapes step in the style editor of a pin legend",
  },
});

export default messages;
